import React from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

interface TabProps {
  [key: string]: number;
}
interface TabsProps {
  list: TabProps;
  activeTab: number;
  onTabClick: (index: number) => void;
}

const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => hexToRgb(theme.colors.state, 0.22)};
  margin-left: 0;
  list-style: none;
  display: flex;
`;

const Tab = styled.h3`
  ${({ theme }) => theme.typography.subTitleLarge};
  cursor: pointer;
  display: inline-block;
  text-transform: capitalize;
  overflow: hidden;
  max-height: 52px;
  white-space: nowrap;
  margin: 0 ${({ theme }) => theme.spacing.spacing40};
  padding: ${({ theme }) => theme.spacing.spacing80}
    ${({ theme }) => theme.spacing.spacing40}
    ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.72)};
  text-align: center;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  }
  &.active {
    color: ${({ theme }) => theme.colors.primary};
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;

const Tabs = ({ list, onTabClick, activeTab = 0 }: TabsProps) => (
  <Wrapper>
    {Object.keys(list)?.map((key: string, index: number) => {
      const isActive = activeTab === index;
      return (
        <Tab
          key={`tabs-${index}`}
          className={`${isActive ? 'active' : ''}`}
          onClick={() => onTabClick(index)}
        >
          {key}
        </Tab>
      );
    })}
  </Wrapper>
);

export default Tabs;
